import { FieldMetaState } from 'react-final-form';

import { INTENT } from './intent';

export const getFieldState = (meta: FieldMetaState<number | string | undefined>, validateOnInit?: boolean | string) => {
  const hasInteracted = validateOnInit || meta.touched || meta.submitFailed;

  const showState = hasInteracted && (!meta.active || meta.submitFailed) && !meta.validating;

  if (showState && meta.invalid) {
    return INTENT.ERROR;
  }

  if (showState && meta.valid) {
    return INTENT.SUCCESS;
  }

  return null;
};
